import { Button, ButtonProps, Modal, ModalProps } from '@payaca/ambrosia';
import { FC, ReactNode } from 'react';

type ProposalConfirmationModalProps = {
  title: string;
  confirmLabel: string;
  confirmColour?: ButtonProps['colour'];
  isPending: boolean;
  onConfirm: () => void;
  children: ReactNode;
} & Omit<ModalProps, 'title'>;

/**
 * Confirmation shell for the Proposal lifecycle actions: the consequences as
 * body copy, a Cancel, and a confirm that shows progress.
 */
const ProposalConfirmationModal: FC<ProposalConfirmationModalProps> = (
  props
) => {
  const {
    title,
    confirmLabel,
    confirmColour,
    isPending,
    onConfirm,
    children,
    onClose,
    ...rest
  } = props;

  return (
    <Modal
      {...rest}
      onClose={onClose}
      title={title}
      // ModalCore gates outside-press and Escape together, and defaults to
      // suppressing both. These hold no unsaved input, so Escape should close.
      disableBackdropClick={false}
    >
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button variant="secondary" onClick={onClose} disabled={isPending}>
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            isProcessing={isPending}
            disabled={isPending}
            colour={confirmColour}
          >
            {confirmLabel}
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ProposalConfirmationModal;
